import { useEffect, useState } from "react";

import useAxios from "@hooks/use-axios";

const useApiKey = () => {
    const { axiosInstance, loading, cancelAllRequests } = useAxios({
        base         : "panel",
        initialLoader: true
    });

    const [data, setData] = useState({ apikey: null });
    const [queryParams, setQueryParams] = useState({});

    const getApiKey = async () => {
        const { data } = await axiosInstance.get("/apikey");
        setData({
            apikey: data
        });
    };

    const regenerateApiKey = async () => {
        const { data } = await axiosInstance.post("/apikey");
        setData({
            apikey: data
        });
        return data;
    };

    useEffect(() => {
        let isActive = true;
        if (isActive) {
            getApiKey();
        }
        return () => {
            isActive = false;
            cancelAllRequests();
        };
    }, [queryParams]);

    return {
        data,
        loading,
        setQueryParams,
        getApiKey,
        regenerateApiKey
    };
};

export default useApiKey;
